import React from "react"
import PropTypes from "prop-types"
import SbEditable from "storyblok-react"
import Components from "../../components"
import linkHandler from "../../helpers/storyblokLinkHandler"

const ClickableArea = ({ blok }) => (
  <SbEditable content={blok}>
    <div className="clickable-area">
      <a className="clickable-area__a" href={linkHandler(blok.href)}>
        &nbsp;
      </a>
      <div className="clickable-area__content">
        {blok.content &&
          blok.content.map((c) =>
            React.createElement(Components(c.component), {
              key: c._uid,
              blok: c,
            })
          )}
      </div>
    </div>
  </SbEditable>
)

ClickableArea.defaultProps = {
  href: "#",
}

ClickableArea.propTypes = {
  blok: PropTypes.shape({
    href: PropTypes.string,
    content: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
}

export default ClickableArea
